import { useQueryCacheUpdater } from "@/hooks/useQueryCacheUpdater";
import { MutationFunction } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/ui/use-toast";
import { Module, PATH_STORE_PROJECT_ASSIGNEES } from "@/constants";
import { ApiError } from "@/services/api";
import { StoreProjectAssigneesService } from "@/services/storeProjectAssignees";
import { useStoreProjectAssigneeId } from "@/modules/storeProjectAssignees/hooks/useStoreProjectAssigneeId";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { generatePath, useNavigate } from "react-router-dom";

export const useDeleteStoreProjectAssignee = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const navigate = useNavigate();
  const id = useStoreProjectAssigneeId();
  const { invalidateListQuery } = useQueryCacheUpdater(
    Module.StoreProjectAssignees,
  );

  const mutationFn: MutationFunction<void, string> = async () => {
    await StoreProjectAssigneesService.delete(id);
  };

  const mutation = useMutationWithErrorHandling<
    unknown,
    ApiError,
    string,
    unknown
  >({
    mutationFn,
    onSuccess: () => {
      toast({
        title: t("storeProjectAssignees.success.delete"),
      });
      invalidateListQuery();
      navigate(generatePath(PATH_STORE_PROJECT_ASSIGNEES));
    },
    errorTitle: t("storeProjectAssignees.errors.delete"),
  });

  return mutation;
};
